import { gql } from 'graphql-tag'
import fragmentBlockIndexContentGroup from '../block-index-content-group/fragment-block-index-content-group'
import { fragmentModuleMedia } from '../../modules/fragments'

export default gql`
  ${fragmentBlockIndexContentGroup}
  ${fragmentModuleMedia}
  fragment BlockIndexChapterFragment on BlockIndexChapter {
    sys {
      id
    }
    title
    contentType: __typename
    navigationTitle
    coverImage {
      ...ModuleMediaFragment
    }
    description
    contentGroupsCollection {
      items {
        ...BlockIndexContentGroupFragment
      }
    }
  }
`
